var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsernameIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "username_icon",
    "data-name": "username icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.612,
    height: 20,
    viewBox: "0 0 20.612 20",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "username_icon-2",
    "data-name": "username icon",
    d: "M18.306,18.612a4.633,4.633,0,0,1-4.831-4.831A4.633,4.633,0,0,1,18.306,8.95a4.633,4.633,0,0,1,4.831,4.831,4.633,4.633,0,0,1-4.831,4.831ZM8,28.95V25.923a3.544,3.544,0,0,1,.612-2.093,3.929,3.929,0,0,1,1.578-1.32,24.208,24.208,0,0,1,4.138-1.449,16.73,16.73,0,0,1,3.977-.483,16.026,16.026,0,0,1,3.961.5,27.435,27.435,0,0,1,4.122,1.433A3.883,3.883,0,0,1,28,23.829a3.544,3.544,0,0,1,.612,2.093V28.95Zm1.932-1.932H26.68v-1.1a1.764,1.764,0,0,0-.306-.982,1.939,1.939,0,0,0-.757-.692,17.1,17.1,0,0,0-3.768-1.369,16.663,16.663,0,0,0-3.543-.37,17.116,17.116,0,0,0-3.575.37,16.358,16.358,0,0,0-3.768,1.369,1.938,1.938,0,0,0-1.031,1.675Zm8.374-10.338a2.809,2.809,0,0,0,2.9-2.9,2.9,2.9,0,1,0-5.8,0,2.809,2.809,0,0,0,2.9,2.9ZM18.306,13.781ZM18.306,27.018Z",
    transform: "translate(-8 -8.95)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsernameIcon);
export default __webpack_public_path__ + "static/media/username_icon.1b1bd12b93bcbf113994b2e91c829fbd.svg";
export { ForwardRef as ReactComponent };